import { isLocalMachine } from "../../utils/api/controlProxy";

const baseUrl = isLocalMachine() ? "/control" : "/d/control";

/** */
export const CREATE_ROOM = () => {
  return `/ss/room/create`;
};

/** */
export const SAVE_ADDRESS = () => {
  return `/ss/user/save-address`;
};

/** */
export const GET_ROOM_INFO = (userId) => {
  return `/ss/room/my-rooms?userLoginId=${userId}`;
};

/** */
export const ASSIGN_ROOM = () => {
  return `/ss/room/assign`;
};
/** */
export const GET_USER_ADDRESS = (userId) => {
  return `/ss/user/address?userLoginId=${userId}`;
};

/** */
export const JOIN_ROOM = () => {
  return `/ss/room/join`;
};

/** */
export const GET_ASSIGNED_PERSON = (roomId, userId) => {
  return `/ss/room/${roomId}/assigned?userLoginId=${userId}`;
};

/** */
export const ADDRESS_TO_USER = () => {
  return `${baseUrl}/update-address-rj`;
};

/** */
export const TRENDING_PRODUCTS = () => {
  return `/chocolate/v1/global/static/santapids`;
};

/** */
export const GET_RECEIVER_ADDRESS = (roomId, userId) => {
  return `/ss/room/${roomId}/receiver-address?userLoginId=${userId}`;
};

/** */
export const GET_REVEAL_INFO = (roomId, userId) => {
  return `/ss/room/${roomId}/reveal?userLoginId=${userId}`;
};
